// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 443 ? "about" : chunkId) + "." + {"2":"d53098e7","298":"223a6508","443":"bcfc960d","567":"9ead778e","781":"0dc9dd8e","928":"2b378432"}[chunkId] + ".js";
};